// // import React, { useState, useEffect, useContext } from 'react';
// // import { Search, X } from 'lucide-react';
// // import { postData } from '../../../../services/Fetchnodeservices';
// // // ⚠️ IMPORTANT: Adjust this path to exactly match where your ThemeContext is located!
// // import { ThemeContext } from '../../../../context/ThemeContext';

// // const ImageSearchModal = ({ isOpen, onClose, query, onSelect }) => {
// //     // 🛡️ SAFE CONTEXT CONSUMPTION WITH FALLBACK
// //     const themeContext = useContext(ThemeContext);
// //     const isDarkMode = themeContext?.currentTheme === 'dark';
    
// //     const fallbackTheme = {
// //         background: isDarkMode ? "#0a0e1a" : "#f8fafc",
// //         surface: isDarkMode ? "#1e293b" : "#ffffff",
// //         surfaceAlt: isDarkMode ? "#0f172a" : "#f1f5f9",
// //         border: isDarkMode ? "#334155" : "#e2e8f0",
// //         textPrimary: isDarkMode ? "#f8fafc" : "#0f172a",
// //         textSecondary: isDarkMode ? "#94a3b8" : "#64748b",
// //         primary: "#6366f1",
// //         primaryLight: "rgba(99, 102, 241, 0.15)",
// //     };

// //     const theme = themeContext?.theme || fallbackTheme;

// //     const [tab, setTab] = useState('web'); // web or server
// //     const [searchTerm, setSearchTerm] = useState(query);
// //     const [results, setResults] = useState([]);
// //     const [loading, setLoading] = useState(false);

// //     useEffect(() => {
// //         if (isOpen) {
// //             setSearchTerm(query);
// //             searchImages(query);
// //         }
// //     }, [isOpen, query, tab]);

// //     const searchImages = async (q) => {
// //         if (!q || q.trim() === '') return;
// //         setLoading(true);
// //         try {
// //             const endpoint = tab === 'web' ? "aimenu/search-web-images" : "aimenu/get-server-images";
// //             const response = await postData(endpoint, { query: q });
// //             if (response.success) setResults(response.images);
// //             else setResults([]);
// //         } catch (e) { 
// //             console.error(e); 
// //             setResults([]);
// //         } finally { 
// //             setLoading(false); 
// //         }
// //     };

// //     const handleSelect = (url) => {
// //         onSelect(url);
// //         onClose();
// //     };

// //     if (!isOpen) return null;

// //     const styles = {
// //         overlay: { 
// //             position: 'fixed', 
// //             inset: 0, 
// //             background: 'rgba(0,0,0,0.8)', 
// //             backdropFilter: 'blur(4px)',
// //             zIndex: 10000, 
// //             display: 'flex', 
// //             alignItems: 'center', 
// //             justifyContent: 'center',
// //             padding: '20px',
// //         },
// //         modal: { 
// //             background: theme.surface, 
// //             width: '100%',
// //             maxWidth: '800px',
// //             maxHeight: '90vh',
// //             borderRadius: '16px', 
// //             padding: '24px', 
// //             color: theme.textPrimary,
// //             boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
// //             display: 'flex',
// //             flexDirection: 'column',
// //             overflow: 'hidden',
// //         },
// //         header: { 
// //             display: 'flex', 
// //             justifyContent: 'space-between', 
// //             alignItems: 'center',
// //             marginBottom: '20px',
// //             paddingBottom: '16px',
// //             borderBottom: `1px solid ${theme.border}`,
// //         },
// //         title: {
// //             margin: 0,
// //             fontSize: '20px',
// //             fontWeight: 700,
// //             color: theme.textPrimary,
// //         },
// //         tabBar: { 
// //             display: 'flex', 
// //             gap: '10px', 
// //             marginBottom: '20px',
// //             padding: '4px',
// //             background: theme.surfaceAlt,
// //             borderRadius: '10px',
// //             width: 'fit-content',
// //         },
// //         tab: { 
// //             padding: '10px 20px', 
// //             background: 'transparent', 
// //             color: theme.textSecondary, 
// //             border: 'none', 
// //             cursor: 'pointer',
// //             borderRadius: '8px',
// //             fontSize: '14px',
// //             fontWeight: 500,
// //             transition: 'all 0.2s',
// //         },
// //         activeTab: { 
// //             padding: '10px 20px', 
// //             background: theme.primary, 
// //             color: '#fff', 
// //             borderRadius: '8px',
// //             cursor: 'pointer',
// //             fontSize: '14px',
// //             fontWeight: 600,
// //             boxShadow: `0 2px 8px ${theme.primary}40`,
// //         },
// //         searchBar: { 
// //             display: 'flex', 
// //             gap: '10px', 
// //             marginBottom: '24px',
// //         },
// //         input: { 
// //             flex: 1, 
// //             background: theme.surfaceAlt, 
// //             border: `1px solid ${theme.border}`, 
// //             color: theme.textPrimary, 
// //             padding: '12px 16px', 
// //             borderRadius: '10px',
// //             fontSize: '14px',
// //             outline: 'none',
// //             transition: 'all 0.2s',
// //         },
// //         searchBtn: { 
// //             background: theme.gradient || theme.primary, 
// //             border: 'none', 
// //             color: 'white', 
// //             padding: '12px 20px', 
// //             borderRadius: '10px',
// //             cursor: 'pointer',
// //             display: 'flex',
// //             alignItems: 'center',
// //             gap: '8px',
// //             fontWeight: 600,
// //             transition: 'all 0.2s',
// //         },
// //         grid: { 
// //             display: 'grid', 
// //             gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', 
// //             gap: '16px', 
// //             overflowY: 'auto',
// //             padding: '4px',
// //         },
// //         card: { 
// //             background: theme.surfaceAlt, 
// //             borderRadius: '12px', 
// //             cursor: 'pointer', 
// //             overflow: 'hidden', 
// //             border: `1px solid ${theme.border}`,
// //             transition: 'all 0.2s',
// //         },
// //         img: { 
// //             width: '100%', 
// //             height: '120px', 
// //             objectFit: 'cover',
// //             display: 'block',
// //         },
// //         imgLabel: { 
// //             fontSize: '11px', 
// //             padding: '8px', 
// //             textAlign: 'center', 
// //             color: theme.textSecondary,
// //             fontWeight: 500,
// //             whiteSpace: 'nowrap',
// //             overflow: 'hidden',
// //             textOverflow: 'ellipsis',
// //         },
// //         closeBtn: { 
// //             background: theme.surfaceAlt, 
// //             border: 'none', 
// //             color: theme.textSecondary,
// //             cursor: 'pointer',
// //             padding: '8px',
// //             borderRadius: '8px',
// //             display: 'flex',
// //             alignItems: 'center',
// //             justifyContent: 'center',
// //             transition: 'all 0.2s',
// //         },
// //         loadingState: {
// //             textAlign: 'center',
// //             padding: '40px',
// //             color: theme.textSecondary,
// //             fontSize: '14px',
// //         },
// //         emptyState: {
// //             textAlign: 'center',
// //             padding: '40px',
// //             color: theme.textSecondary,
// //             fontSize: '14px',
// //             gridColumn: '1 / -1',
// //         },
// //     };

// //     return (
// //         <div style={styles.overlay} onClick={onClose}>
// //             <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
// //                 <div style={styles.header}>
// //                     <h3 style={styles.title}>Find Image: {query}</h3>
// //                     <button 
// //                         onClick={onClose} 
// //                         style={styles.closeBtn}
// //                         onMouseEnter={(e) => {
// //                             e.currentTarget.style.background = theme.border;
// //                             e.currentTarget.style.color = theme.textPrimary;
// //                         }}
// //                         onMouseLeave={(e) => {
// //                             e.currentTarget.style.background = theme.surfaceAlt;
// //                             e.currentTarget.style.color = theme.textSecondary;
// //                         }}
// //                     >
// //                         <X size={20} />
// //                     </button>
// //                 </div>

// //                 <div style={styles.tabBar}>
// //                     <button 
// //                         onClick={() => setTab('server')} 
// //                         style={tab === 'server' ? styles.activeTab : styles.tab}
// //                         onMouseEnter={(e) => {
// //                             if (tab !== 'server') {
// //                                 e.currentTarget.style.background = theme.border;
// //                                 e.currentTarget.style.color = theme.textPrimary;
// //                             }
// //                         }}
// //                         onMouseLeave={(e) => {
// //                             if (tab !== 'server') {
// //                                 e.currentTarget.style.background = 'transparent';
// //                                 e.currentTarget.style.color = theme.textSecondary;
// //                             }
// //                         }}
// //                     >
// //                         Self Server
// //                     </button>
// //                     <button 
// //                         onClick={() => setTab('web')} 
// //                         style={tab === 'web' ? styles.activeTab : styles.tab}
// //                         onMouseEnter={(e) => {
// //                             if (tab !== 'web') {
// //                                 e.currentTarget.style.background = theme.border;
// //                                 e.currentTarget.style.color = theme.textPrimary;
// //                             }
// //                         }}
// //                         onMouseLeave={(e) => {
// //                             if (tab !== 'web') {
// //                                 e.currentTarget.style.background = 'transparent';
// //                                 e.currentTarget.style.color = theme.textSecondary;
// //                             }
// //                         }}
// //                     >
// //                         Internet Search
// //                     </button>
// //                 </div>

// //                 <div style={styles.searchBar}>
// //                     <input 
// //                         style={styles.input} 
// //                         value={searchTerm} 
// //                         onChange={(e) => setSearchTerm(e.target.value)}
// //                         onKeyDown={(e) => e.key === 'Enter' && searchImages(searchTerm)}
// //                         placeholder="Search for images..."
// //                         onFocus={(e) => {
// //                             e.target.style.borderColor = theme.primary;
// //                             e.target.style.boxShadow = `0 0 0 3px ${theme.primaryLight}`;
// //                         }}
// //                         onBlur={(e) => {
// //                             e.target.style.borderColor = theme.border;
// //                             e.target.style.boxShadow = 'none';
// //                         }}
// //                     />
// //                     <button 
// //                         style={styles.searchBtn} 
// //                         onClick={() => searchImages(searchTerm)}
// //                         disabled={loading}
// //                         onMouseEnter={(e) => {
// //                             if (!loading) {
// //                                 e.currentTarget.style.filter = 'brightness(1.1)';
// //                                 e.currentTarget.style.transform = 'translateY(-1px)';
// //                             }
// //                         }}
// //                         onMouseLeave={(e) => {
// //                             e.currentTarget.style.filter = 'brightness(1)';
// //                             e.currentTarget.style.transform = 'translateY(0)';
// //                         }}
// //                     >
// //                         <Search size={18} />
// //                         {loading ? 'Searching...' : 'Search'}
// //                     </button>
// //                 </div>

// //                 <div style={styles.grid}>
// //                     {loading ? (
// //                         <div style={styles.loadingState}>Searching for images...</div>
// //                     ) : results.length === 0 ? (
// //                         <div style={styles.emptyState}>No images found. Try a different search term.</div>
// //                     ) : (
// //                         results.map((img, i) => (
// //                             <div 
// //                                 key={i} 
// //                                 style={styles.card} 
// //                                 onClick={() => handleSelect(img.filename || img.url)}
// //                                 onMouseEnter={(e) => {
// //                                     e.currentTarget.style.transform = 'translateY(-4px)';
// //                                     e.currentTarget.style.boxShadow = `0 8px 16px ${theme.primary}20`;
// //                                     e.currentTarget.style.borderColor = theme.primary;
// //                                 }}
// //                                 onMouseLeave={(e) => {
// //                                     e.currentTarget.style.transform = 'translateY(0)';
// //                                     e.currentTarget.style.boxShadow = 'none';
// //                                     e.currentTarget.style.borderColor = theme.border;
// //                                 }}
// //                             >
// //                                 <img 
// //                                     src={img.url?.startsWith('http') ? img.url : `https://zaptodoor.com/upload/${img.url}`} 
// //                                     style={styles.img} 
// //                                     alt={img.name || `Image ${i + 1}`}
// //                                     onError={(e) => {
// //                                         e.target.src = 'https://via.placeholder.com/150x120?text=No+Image';
// //                                     }}
// //                                 />
// //                                 <div style={styles.imgLabel}>{img.name || `Image ${i + 1}`}</div>
// //                             </div>
// //                         ))
// //                     )}
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // export default ImageSearchModal;

// import React, { useState, useEffect } from 'react';
// import { Search, Globe, Server, X, Check } from 'lucide-react';
// import { postData, getData } from '../../../../services/Fetchnodeservices';

// const ImageSearchModal = ({ isOpen, onClose, query, onSelect }) => {
//     const [tab, setTab] = useState('web'); // web or server
//     const [searchTerm, setSearchTerm] = useState(query);
//     const [results, setResults] = useState([]);
//     const [loading, setLoading] = useState(false);

//     useEffect(() => {
//         if (isOpen) {
//             setSearchTerm(query);
//             searchImages(query);
//         }
//     }, [isOpen, query, tab]);

//     const searchImages = async (q) => {
//         setLoading(true);
//         try {
//             // ये रूट आपके बैकएंड में Wikipedia या Google से इमेज लाएगा
//             const endpoint = tab === 'web' ? "aimenu/search-web-images" : "aimenu/get-server-images";
//             const response = await postData(endpoint, { query: q });
//             if (response.success) setResults(response.images);
//         } catch (e) { console.error(e); }
//         finally { setLoading(false); }
//     };

//     if (!isOpen) return null;

//     return (
//         <div style={styles.overlay}>
//             <div style={styles.modal}>
//                 <div style={styles.header}>
//                     <h3>Find Image: {query}</h3>
//                     <button onClick={onClose} style={styles.closeBtn}><X /></button>
//                 </div>

//                 <div style={styles.tabBar}>
//                     <button onClick={() => setTab('server')} style={tab === 'server' ? styles.activeTab : styles.tab}>Self Server</button>
//                     <button onClick={() => setTab('web')} style={tab === 'web' ? styles.activeTab : styles.tab}>Internet Search</button>
//                 </div>

//                 <div style={styles.searchBar}>
//                     <input 
//                         style={styles.input} 
//                         value={searchTerm} 
//                         onChange={(e) => setSearchTerm(e.target.value)} 
//                     />
//                     <button style={styles.searchBtn} onClick={() => searchImages(searchTerm)}><Search size={18} /></button>
//                 </div>

//                 <div style={styles.grid}>
//                     {loading ? <p>Searching...</p> : results.map((img, i) => (
//                         <div key={i} style={styles.card} onClick={() => onSelect(img.filename || img.url)}>
//                             <img src={img.url.startsWith('http') ? img.url : `https://zaptodoor.com/upload/${img.url}`} style={styles.img} />
//                             <div style={styles.imgLabel}>{img.name || "Select"}</div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// };

// const styles = {
//     overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' },
//     modal: { background: '#1e293b', width: '800px', borderRadius: '12px', padding: '20px', color: 'white' },
//     header: { display: 'flex', justifyContent: 'space-between', marginBottom: '20px' },
//     tabBar: { display: 'flex', gap: '10px', marginBottom: '15px', borderBottom: '1px solid #334155' },
//     tab: { padding: '10px', background: 'transparent', color: '#94a3b8', border: 'none', cursor: 'pointer' },
//     activeTab: { padding: '10px', background: 'transparent', color: '#a855f7', borderBottom: '2px solid #a855f7', cursor: 'pointer' },
//     searchBar: { display: 'flex', gap: '10px', marginBottom: '20px' },
//     input: { flex: 1, background: '#0f172a', border: '1px solid #334155', color: 'white', padding: '10px', borderRadius: '6px' },
//     searchBtn: { background: '#3b82f6', border: 'none', color: 'white', padding: '0 15px', borderRadius: '6px' },
//     grid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px', maxHeight: '400px', overflowY: 'auto' },
//     card: { background: '#0f172a', borderRadius: '8px', cursor: 'pointer', overflow: 'hidden', border: '1px solid #334155' },
//     img: { width: '100%', height: '120px', objectFit: 'cover' },
//     imgLabel: { fontSize: '10px', padding: '5px', textAlign: 'center', color: '#94a3b8' },
//     closeBtn: { background: 'transparent', border: 'none', color: 'white' }
// };

// export default ImageSearchModal;


import React, { useContext, useEffect, useState } from "react";
import { Search, Globe, Server, X, Check } from "lucide-react";

import { postData } from "../../../../services/Fetchnodeservices";
import { ThemeContext } from "../../../../context/ThemeContext";

const ImageSearchModal = ({ isOpen, onClose, query, onSelect }) => {
  const themeContext = useContext(ThemeContext);
  const isDark = themeContext?.currentTheme === "dark";

  const fallbackTheme = {
    background: isDark ? "#0f172a" : "#f8fafc",
    surface: isDark ? "#1e293b" : "#ffffff",
    surfaceLighter: isDark ? "#334155" : "#f1f5f9",
    border: isDark ? "#475569" : "#e2e8f0",
    textPrimary: isDark ? "#f8fafc" : "#0f172a",
    textSecondary: isDark ? "#cbd5e1" : "#334155",
    textMuted: isDark ? "#94a3b8" : "#64748b",
    primary: "#6366f1",
    primaryLight: "rgba(99, 102, 241, 0.15)",
    primaryGradient: "linear-gradient(135deg, #6366f1, #8b5cf6)",
  };

  const brandTheme = themeContext?.theme || fallbackTheme;

  const ts = {
    background: brandTheme.background || fallbackTheme.background,
    surface: brandTheme.surface || fallbackTheme.surface,
    surfaceLighter:
      brandTheme.surfaceLighter ||
      (isDark ? "#334155" : "#f1f5f9"),
    border: brandTheme.border || fallbackTheme.border,
    textPrimary: brandTheme.textPrimary || fallbackTheme.textPrimary,
    textSecondary: brandTheme.textSecondary || fallbackTheme.textSecondary,
    textMuted: brandTheme.textMuted || fallbackTheme.textMuted,
    primary: brandTheme.primary || fallbackTheme.primary,
    primaryLight: brandTheme.primaryLight || fallbackTheme.primaryLight,
    gradient:
      brandTheme.primaryGradient ||
      `linear-gradient(135deg, ${brandTheme.primary || fallbackTheme.primary}, ${
        brandTheme.primaryDark || brandTheme.primary || fallbackTheme.primary
      })`,
  };

  const [tab, setTab] = useState("web");
  const [searchTerm, setSearchTerm] = useState(query || "");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const searchImages = async (searchValue) => {
    const cleanQuery = searchValue?.trim();

    if (!cleanQuery) {
      setResults([]);
      return;
    }

    setLoading(true);

    try {
      const endpoint =
        tab === "web"
          ? "aimenu/search-web-images"
          : "aimenu/get-server-images";

      const response = await postData(endpoint, { query: cleanQuery });

      if (response?.success) {
        setResults(response.images || []);
      } else {
        setResults([]);
      }
    } catch (error) {
      console.error("Image search failed:", error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isOpen) return;

    setSearchTerm(query || "");
    searchImages(query || "");
  }, [isOpen, query, tab]);

  const handleSelect = (imageUrl) => {
    onSelect(imageUrl);
    onClose();
  };

  const styles = {
    overlay: {
      position: "fixed",
      inset: 0,
      background: "rgba(0, 0, 0, 0.72)",
      backdropFilter: "blur(5px)",
      zIndex: 10000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px",
    },
    modal: {
      background: ts.surface,
      width: "100%",
      maxWidth: "800px",
      maxHeight: "90vh",
      borderRadius: "16px",
      padding: "24px",
      color: ts.textPrimary,
      border: `1px solid ${ts.border}`,
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.30)",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "20px",
      paddingBottom: "16px",
      borderBottom: `1px solid ${ts.border}`,
    },
    tabBar: {
      display: "flex",
      gap: "10px",
      marginBottom: "20px",
      padding: "4px",
      background: ts.surfaceLighter,
      borderRadius: "10px",
      width: "fit-content",
    },
    tab: {
      padding: "10px 20px",
      background: "transparent",
      color: ts.textSecondary,
      border: "none",
      cursor: "pointer",
      borderRadius: "8px",
      fontSize: "14px",
      fontWeight: 500,
    },
    activeTab: {
      padding: "10px 20px",
      background: ts.gradient,
      color: "#ffffff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: 600,
      boxShadow: `0 2px 8px ${ts.primary}40`,
    },
    searchBar: {
      display: "flex",
      gap: "10px",
      marginBottom: "24px",
    },
    input: {
      flex: 1,
      background: ts.surfaceLighter,
      border: `1px solid ${ts.border}`,
      color: ts.textPrimary,
      padding: "12px 16px",
      borderRadius: "10px",
      fontSize: "14px",
      outline: "none",
    },
    searchBtn: {
      background: ts.gradient,
      border: "none",
      color: "#ffffff",
      padding: "12px 20px",
      borderRadius: "10px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontWeight: 600,
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
      gap: "16px",
      overflowY: "auto",
      padding: "4px",
    },
    card: {
      background: ts.surfaceLighter,
      borderRadius: "12px",
      cursor: "pointer",
      overflow: "hidden",
      border: `1px solid ${ts.border}`,
      transition: "all 0.2s ease",
    },
    image: {
      width: "100%",
      height: "120px",
      objectFit: "cover",
      display: "block",
    },
    imageLabel: {
      fontSize: "11px",
      padding: "8px",
      textAlign: "center",
      color: ts.textSecondary,
      fontWeight: 500,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    closeBtn: {
      background: ts.surfaceLighter,
      border: "none",
      color: ts.textSecondary,
      cursor: "pointer",
      padding: "8px",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    state: {
      textAlign: "center",
      padding: "40px",
      color: ts.textSecondary,
      fontSize: "14px",
      gridColumn: "1 / -1",
    },
  };

  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(event) => event.stopPropagation()}>
        <div style={styles.header}>
          <h3
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: 700,
              color: ts.textPrimary,
            }}
          >
            Find Image: {query}
          </h3>

          <button type="button" onClick={onClose} style={styles.closeBtn}>
            <X size={20} />
          </button>
        </div>

        <div style={styles.tabBar}>
          <button
            type="button"
            onClick={() => setTab("server")}
            style={tab === "server" ? styles.activeTab : styles.tab}
          >
            <Server size={15} style={{ verticalAlign: "middle" }} /> Self Server
          </button>

          <button
            type="button"
            onClick={() => setTab("web")}
            style={tab === "web" ? styles.activeTab : styles.tab}
          >
            <Globe size={15} style={{ verticalAlign: "middle" }} /> Internet Search
          </button>
        </div>

        <div style={styles.searchBar}>
          <input
            style={styles.input}
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter") searchImages(searchTerm);
            }}
            placeholder="Search for images..."
            onFocus={(event) => {
              event.currentTarget.style.borderColor = ts.primary;
              event.currentTarget.style.boxShadow = `0 0 0 3px ${ts.primaryLight}`;
            }}
            onBlur={(event) => {
              event.currentTarget.style.borderColor = ts.border;
              event.currentTarget.style.boxShadow = "none";
            }}
          />

          <button
            type="button"
            style={{
              ...styles.searchBtn,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? "not-allowed" : "pointer",
            }}
            onClick={() => searchImages(searchTerm)}
            disabled={loading}
          >
            <Search size={18} />
            {loading ? "Searching..." : "Search"}
          </button>
        </div>

        <div style={styles.grid}>
          {loading ? (
            <div style={styles.state}>Searching for images...</div>
          ) : results.length === 0 ? (
            <div style={styles.state}>
              No images found. Try a different search term.
            </div>
          ) : (
            results.map((image, index) => {
              const selectedUrl = image.filename || image.url;
              const displayUrl = image.url?.startsWith("http")
                ? image.url
                : `https://zaptodoor.com/upload/${image.url}`;

              return (
                <div
                  key={`${selectedUrl}-${index}`}
                  style={styles.card}
                  onClick={() => handleSelect(selectedUrl)}
                  onMouseEnter={(event) => {
                    event.currentTarget.style.transform = "translateY(-4px)";
                    event.currentTarget.style.boxShadow = `0 8px 16px ${ts.primary}25`;
                    event.currentTarget.style.borderColor = ts.primary;
                  }}
                  onMouseLeave={(event) => {
                    event.currentTarget.style.transform = "translateY(0)";
                    event.currentTarget.style.boxShadow = "none";
                    event.currentTarget.style.borderColor = ts.border;
                  }}
                >
                  <img
                    src={displayUrl}
                    style={styles.image}
                    alt={image.name || `Image ${index + 1}`}
                    onError={(event) => {
                      event.currentTarget.src =
                        "https://via.placeholder.com/150x120?text=No+Image";
                    }}
                  />

                  <div style={styles.imageLabel}>
                    <Check
                      size={12}
                      color={ts.primary}
                      style={{ verticalAlign: "middle", marginRight: "4px" }}
                    />
                    {image.name || "Select Image"}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageSearchModal;